import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../../utils/axiosInstance";

// Modify the thunk to accept search parameters for name, startDate, and endDate
export const collateralApi = createAsyncThunk(
  "collateral",
  async () => {
    const response = await axiosInstance.get(`/getcollateral`);
    return response.data;
  }
);

const collateralSlice = createSlice({
  name: "collateral",
  initialState: {
    collateral: [],
    errors: [],
    loading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(collateralApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(collateralApi.fulfilled, (state, action) => {
        state.collateral = action.payload;
        state.loading = false;
      })
      .addCase(collateralApi.rejected, (state, action) => {
        state.errors.push(action.error.message);
        state.loading = false;
      });
  },
});

export default collateralSlice.reducer;
